import React from 'react';
import { LazyComponent } from '../../../components/LazyComponents';
// @ts-ignore
const ProfilePageLazy = React.lazy(() => import('./ProfilePage'));

export function LazyProfilePage() {
  return <LazyComponent lazyComponent={<ProfilePageLazy />} />;
}
